/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import { CButton, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CSpinner  } from '@coreui/react'
import { CBadge, CCardTitle, CFormInput, CFormLabel, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormSelect, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import { Cog, Filter , X, GripVertical } from 'lucide-react'
import SaveBoard from '../../../services/general/BoardCrud.api'
import toast from 'react-hot-toast'
import Select from 'react-select'
import RegisterUser from '../../../services/general/register.api'
import { createDefaultKanbanColumns, normalizeKanbanColumns } from '../kanban-components/kanbanStatusUtils'
import { toastConfig } from '../../../constants/other.config'
import {  extractBoardsFromCrudResponse, parseCrudPayload} from './boardApiUtils'


const applyColumnOrder = (columns = []) =>
  columns.map((column, index) => ({
    ...column,
    order: index + 1,
  }))


const DEFAULT_BOARD_COLUMNS = applyColumnOrder(createDefaultKanbanColumns())

const normalizeWatcherRecord = (watcher) => {
  if (!watcher) return null

  const resolvedId = String(
    watcher?.ref_id ||
    watcher?.refId ||
    watcher?.RefId ||
    watcher?.RefID ||
    watcher?.UserID ||
    watcher?.UserId ||
    watcher?.userId ||
    watcher?.id ||
    watcher?.Id ||
    watcher?.value ||
    watcher?.Username ||
    watcher?.username ||
    watcher?.name ||
    watcher?.openTo ||
    ''
  ).trim()

  const label = String(
    watcher?.label ||
    watcher?.Username ||
    watcher?.username ||
    watcher?.name ||
    watcher?.Name ||
    watcher?.email ||
    watcher?.Email ||
    watcher?.openTo ||
    resolvedId ||
    ''
  ).trim()

  if (!resolvedId && !label) return null

  return {
    ...watcher,
    value: resolvedId || label,
    label: label || resolvedId,
  }


}

const DeleteBoard = ({ fetchBoard, boardData }) => {
  const [todos, setTodos] = useState([])
  const { id } = useParams()
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
   const [loading, setLoading] = useState(true)
  const [editBoardState, setEditBoardState] = useState({
    id: Date.now(),
    title: '',
    description: '',
    tasks: [],
    columns: DEFAULT_BOARD_COLUMNS.map((column) => ({
      ...column,
      isSystem: column.headerText === 'Completed' || column.headerText === 'Archived',
    })),
    taskWatchers: [],
    openTo: [],
    createdBy: '',
  })
  const [draggedColumnIndex, setDraggedColumnIndex] = useState(null)
  const [dragOverColumnIndex, setDragOverColumnIndex] = useState(null)
  const [users, setUsers] = useState([])

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const watcherOptions = users.map((user) => ({
  value: user?.Id || user?.UserId || user?.UserID,
  label: user?.Username || user?.Email,
  userData: user,
}))


  const GetAllUsers = async () => {
    try {
      const response = await RegisterUser('', '', '', '', 'get_all')
      const allUsers = response?.d?.Users || []
      setUsers(allUsers)
    } catch (err) {}
  }

   const getTodos = async () => {
    try {
      const response = await SaveBoard('GET_ALL')

      const boards = extractBoardsFromCrudResponse(response)

      if (boards.length) {
        setTodos(boards)
      } else {
        setTodos([])
      }
    } catch (err) {
      console.error('Unexpected error loading boards:', err)
      setTodos([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    GetAllUsers()
    getTodos()
  }, [])

  const applyColumnOrder = (columns = []) =>
    columns.map((column, index) => ({
      ...column,
      order: index + 1,
    }))


  const enforceSystemColumns = (columns = []) => {
    const isSys = (name) => {
      const normalized = String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '')
      return normalized === 'completed' || normalized === 'archived' || normalized === 'archive' || normalized === 'achived' || normalized === 'achive'
    }

    const seenSys = new Set()

    const safeColumns = columns.reduce((acc, c) => {
      const isColSys = isSys(c.keyField) || isSys(c.headerText);
      
      if (isColSys) {
        const normKey = String(c.keyField || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        const normHeader = String(c.headerText || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        const type = (normKey === 'completed' || normHeader === 'completed') ? 'completed' : 'archived';
        
        if (seenSys.has(type)) return acc;
        seenSys.add(type);
      }
      
      acc.push({ ...c, isSystem: isColSys });
      return acc;
    }, []);

    if (!seenSys.has('completed')) safeColumns.push({ headerText: 'Completed', keyField: 'Completed', isSystem: true });
    if (!seenSys.has('archived')) safeColumns.push({ headerText: 'Archived', keyField: 'Archived', isSystem: true });

    return safeColumns;
  }

  const reorderBoardColumn = (fromIndex, toIndex) => {
    if (
      fromIndex === null ||
      toIndex === null ||
      !Number.isInteger(fromIndex) ||
      !Number.isInteger(toIndex) ||
      fromIndex === toIndex
    ) return

    setEditBoardState((prev) => {
      if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= prev.columns.length ||
        toIndex >= prev.columns.length
      ) return prev

      const nextColumns = [...prev.columns]
      const [movedColumn] = nextColumns.splice(fromIndex, 1)
      nextColumns.splice(toIndex, 0, movedColumn)

      return {
        ...prev,
        columns: applyColumnOrder(nextColumns),
      }
    })
  }

  const handleColumnDragStart = (event, index) => {
    setDraggedColumnIndex(index)
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/plain', String(index))
  }

  const handleColumnDrop = (event, targetIndex) => {
    event.preventDefault()
    const sourceIndex = draggedColumnIndex ?? Number(event.dataTransfer.getData('text/plain'))

    reorderBoardColumn(sourceIndex, targetIndex)
    setDraggedColumnIndex(null)
    setDragOverColumnIndex(null)
  }

  const handleColumnDragEnd = () => {
    setDraggedColumnIndex(null)
    setDragOverColumnIndex(null)
  }

  const handleDelete = async () => {
    try {
      const response = await SaveBoard('DELETE', null, id)
      
      const parsed = typeof response?.d === 'string' ? JSON.parse(response.d) : response
      
      if (parsed?.success) {
        toast.success('Board deleted successfully', toastConfig)
        setTimeout(() => {
          window.location.href = "/home/all-tasks"
        }, 500)
      } else {
        toast.error(parsed?.message || 'Failed to delete board', toastConfig)
      }
    } catch (error) {
      console.error('Delete error:', error)
      toast.error('Error deleting board', toastConfig)
    }
    setShowDeleteModal(false)
  }

  const handleEditClick = async () => {
  const setBoardForEdit = (board) => {
    setEditBoardState({
      id,
      title: board?.name || board?.title || '',
      description: board?.description || '',
      tasks: [],
      columns: applyColumnOrder(
        enforceSystemColumns(board?.columns || [])
      ),

      taskWatchers: (board?.members || []).map((user) => ({
        value: String(user?.ref_id),
        label: user?.name || user?.email || '',
      })),
    })

    setShowEditModal(true)
  }

  try {
    setIsLoading(true)

    const response = await SaveBoard('GET', null, id)

    const parsed =
      typeof response?.d === 'string'
        ? JSON.parse(response.d)
        : response

    const rawData = parsed?.data || []

    const [boardRows = [], statusRows = [], memberRows = []] = rawData

    const boardInfo = Array.isArray(boardRows)
      ? boardRows[0]
      : boardRows

    const board = {
      ...boardInfo,

      columns: statusRows.map((status) => ({
        headerText: status?.StatusName,
        keyField: String(status?.StatusId),
        wipLimit: status?.wip_limit || 0,
      })),

      members: memberRows,
    }

    console.log('EDIT BOARD:', board)

    setBoardForEdit(board)
  } catch (error) {
    console.error('Board edit load error:', error)
    setBoardForEdit({})
  } finally {
    setIsLoading(false)
  }
}

 

    
    const handleSaveEdit = async () => {
      try {
        if (!editBoardState.title?.trim()) {
          toast.error('Board title is required', toastConfig)
          return
        }
  
        if (!editBoardState.columns?.length) {
          toast.error('Please add at least one column', toastConfig)
          return
        }
  
        const hasEmptyColumn = editBoardState.columns.some(
          (col) => !col.headerText?.trim()
        )
  
        if (hasEmptyColumn) {
          toast.error('Column name cannot be empty', toastConfig)
          return
        }
  
        const columnNames = editBoardState.columns.map((c) =>
          c.headerText.trim().toLowerCase()
        )
  
        const hasDuplicate = new Set(columnNames).size !== columnNames.length
  
        if (hasDuplicate) {
          toast.error('Column names must be unique', toastConfig)
          return
        }
  
        const titleToCheck = editBoardState.title.trim()
  
      const existingBoards = todos || []
      const duplicateBoard = existingBoards.some(
        (board) =>
          String(board?.id || board?.Id || board?.boardId) !== String(id) &&
          String(board?.title || board?.Title || board?.name || '').toLowerCase() === titleToCheck.toLowerCase(),
      )
  
      if (duplicateBoard) {
        toast.error('A board with this title already exists!', toastConfig)
        return
      }
  
     const normalizedColumns = applyColumnOrder(
    normalizeKanbanColumns(editBoardState.columns)
  ).map((column, index) => ({
    name: column.headerText,
    HeaderText: column.headerText,
    StatusName: column.headerText,
    keyField: column.keyField,
    StatusId: column.keyField,
    order: index + 1,
    wipLimit: column.wipLimit || 0
  }))
  
  const selectedUsers = editBoardState.openTo || editBoardState.taskWatchers || []

  const members = (selectedUsers || [])
    .map((user) => {
      const resolvedFromOption = watcherOptions.find(
        (option) => String(option.value).trim() === String(user?.value || user?.UserID || user?.UserId || user?.id || user?.Id || '').trim()
      )

      const resolvedFromLabel = watcherOptions.find(
        (option) => String(option.label || '').trim().toLowerCase() === String(user?.label || user?.Username || user?.username || user?.name || '').trim().toLowerCase()
      )

      const resolved = resolvedFromOption || resolvedFromLabel || user
      const refId = String(
        resolved?.UserID ||
        resolved?.UserId ||
        resolved?.id ||
        resolved?.Id ||
        resolved?.value ||
        ''
      ).trim()

      if (!refId) return null

      const username = String(
        resolved?.Username ||
        resolved?.username ||
        resolved?.label ||
        resolved?.name ||
        refId
      ).trim()

      return {
        ref_id: refId,
        Id: refId,
        name: username,
        Username: username,
      }
    })
    .filter(Boolean)

  const boardPayload = {
    title: titleToCheck,
    description: editBoardState.description || '',
    columns: normalizedColumns,
    createdBy: {
      id: userData?.UserID || userData?.Id || userData?.UserId || userData?.id || 1,
      name: userData?.Username || userData?.username || userData?.Name || userData?.name || ''
    },
    
        members:
  editBoardState.taskWatchers?.map((user) => ({
    ref_id: user?.value,
    UserId: user?.value,
    Username: user?.label,
  })) || [],
  }
  const response = await SaveBoard({ mode: 'UPDATE', boardData: boardPayload, boardId: id })
  const parsed = parseCrudPayload(response) || {}
  const savedBoards = extractBoardsFromCrudResponse(response)
  const savedBoard = savedBoards[0] || { ...boardPayload, id, boardId: id, name: titleToCheck }

  if (!parsed?.success || !savedBoard) {
    toast.error(parsed?.message || 'Failed to update board', toastConfig)
    return
  }
      // mergeCachedBoards([savedBoard])
    await getTodos()
      if (typeof fetchBoard === 'function') await fetchBoard()
      setShowEditModal(false)
       
        setEditBoardState({
          id: Date.now(),
          title: '',
          description: '',
          tasks: [],
          columns: DEFAULT_BOARD_COLUMNS.map((column) => ({
            ...column,
            isSystem: column.headerText === 'Completed' || column.headerText === 'Archived',
          })),
          taskWatchers: [],
          openTo: [],
        })
      } catch (error) {
        console.error(error)
        toast.error('Something went wrong', toastConfig)
      }
    }

  return (
    <div className="task-board-settings">
    <CDropdown alignment="end" className="task-board-settings-dropdown">
  <CDropdownToggle
    color={role === "provider" ? "dark" : "light"}
    className="d-flex align-items-center gap-2 task-board-settings-toggle"
  >
    <Cog strokeWidth={1} size={18} />
  </CDropdownToggle>

  <CDropdownMenu 
   className="task-board-settings-menu"
    //className={role === "provider" ? "dropdown-menu-dark" : "dropdown-menu-light"}  
  >
    <CDropdownItem className="task-board-settings-item" onClick={handleEditClick} style={{ cursor: "pointer" }}>Edit Board</CDropdownItem>
    <CDropdownItem
      className="task-board-settings-item"
      style={{ cursor: "pointer", color: "rgb(231, 0, 0)" }}
      onClick={() => setShowDeleteModal(true)}>
      Delete Board
    </CDropdownItem>
  </CDropdownMenu>
</CDropdown>


      <CModal 
        visible={showDeleteModal} 
        backdrop="static" 
        onClose={() => setShowDeleteModal(false)} 
        className="hrm-confirm-modal"
        centered
      >
        <CModalHeader onClose={() => setShowDeleteModal(false)}>
          <CModalTitle>Delete Board</CModalTitle>
        </CModalHeader>
        <CModalBody>
          Are you sure you want to delete this board?
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </CButton>
          <CButton onClick={handleDelete} color="danger" className="hrm-modal-danger-btn">Delete</CButton>
        </CModalFooter>
      </CModal>

      {/* Edit Board Modal */}
      <CModal backdrop={'static'} visible={showEditModal} onClose={() => setShowEditModal(false)} scrollable size="xl" className="task-jira-modal dashboard-dark-modal patient-theme-modal kanban-board-modal">
        <CModalHeader className="dashboard-dark-modal-header" style={{ border: '0', padding: '20px 24px 0' }}>
          <CModalTitle style={{ fontSize: '16px', fontWeight: 600, color: 'var(--ui-text-primary)' }}>Edit Board</CModalTitle>
        </CModalHeader>
        <CModalBody className="dashboard-dark-modal-body" style={{ padding: '20px 24px' }}>
          <div style={{ display: 'grid', gap: '24px' }}>
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', marginBottom: '6px', display: 'block' }}>Title</label>
              <CFormInput
                placeholder="Enter board title"
                value={editBoardState.title}
                onChange={(e) => setEditBoardState(p => ({ ...p, title: e.target.value }))}
                style={{
                  border: '1px solid #DFE1E6',
                  borderRadius: '6px',
                  fontSize: '13px',
                  padding: '10px 12px',
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', marginBottom: '6px', display: 'block' }}>Description</label>
              <CFormTextarea
                placeholder="Describe what this board is for"
                rows={4}
                value={editBoardState.description}
                onChange={(e) => setEditBoardState(p => ({ ...p, description: e.target.value }))}
                style={{
                  border: '1px solid #DFE1E6',
                  borderRadius: '6px',
                  fontSize: '13px',
                  padding: '10px 12px',
                  fontFamily: 'inherit',
                }}
              />
            </div>
            {/* Task Watchers Section */}
            {false && (
              <div>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', marginBottom: '6px', display: 'block' }}>Watchers</label>
                <Select
                  isMulti
                  options={watcherOptions}
                  value={editBoardState.openTo || editBoardState.taskWatchers}
                  onChange={(selected) => {
                    setEditBoardState((p) => ({
                      ...p,
                      taskWatchers: selected || [],
                      openTo: selected || [],
                    }))
                  }}
                  placeholder="Add Watchers"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '42px',
                      borderRadius: '6px',
                      border: '1px solid #DFE1E6',
                      boxShadow: 'none',
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                />
              </div>
            )}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', margin: 0 }}>Columns</label>
                <span
                  style={{
                    fontSize: '12px',
                    padding: '6px 12px',
                    color: 'var(--ui-text-primary)',
                    fontWeight: 500,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setEditBoardState(p => ({
                      ...p,
                      columns: applyColumnOrder([
                        ...(p.columns || []),
                        {
                          headerText: '',
                          keyField: Date.now(),
                          order: (p.columns?.length || 0) + 1,
                          isCollapse: false,
                          isSystem: false,
                        }
                      ]),
                    }))
                  }}
                >
                  + Add Column
                </span>
              </div>
              <div style={{ display: 'grid', gap: '8px' }}>
                {(editBoardState.columns || []).map((item, idx) => {
                  const isDragSource = draggedColumnIndex === idx
                  const isDropTarget = dragOverColumnIndex === idx && draggedColumnIndex !== idx

                  return (
                  <div
                    key={`${item.keyField || item.headerText}-${idx}`}
                    draggable
                    onDragStart={(event) => handleColumnDragStart(event, idx)}
                    onDragOver={(event) => {
                      event.preventDefault()
                      event.dataTransfer.dropEffect = 'move'
                    }}
                    onDragEnter={() => setDragOverColumnIndex(idx)}
                    onDrop={(event) => handleColumnDrop(event, idx)}
                    onDragEnd={handleColumnDragEnd}
                      className={`d-flex align-items-center p-1 rounded ${isDropTarget ? 'drop-target-active' : ''}`}
                      style={{
                        gap: '10px',
                        background: isDropTarget ? 'var(--ui-dashboard-surface-3, #E9F2FF)' : 'transparent',
                        opacity: isDragSource ? 0.6 : 1,
                      cursor: 'grab',
                      transition: 'background 0.15s ease, opacity 0.15s ease',
                    }}
                  >
                    <span
                      aria-hidden="true"
                      style={{
                        width: '28px',
                        height: '40px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#98A2B3',
                        cursor: 'grab',
                        flexShrink: 0,
                      }}
                    >
                      <GripVertical size={18} />
                    </span>
                    <CFormInput
                      placeholder={`Column ${idx + 1} Name`}
                      value={item.headerText}
                      onChange={(e) => {
                        setEditBoardState(p => ({
                          ...p,
                          columns: p.columns.map((col, j) => j === idx ? { ...col, headerText: e.target.value } : col)
                        }))
                      }}
                      disabled={item.isSystem}
                      style={{
                        border: '1px solid #DFE1E6',
                        borderRadius: '6px',
                        fontSize: '13px',
                        padding: '10px 12px',
                        flex: 1,
                        opacity: item.isSystem ? 0.6 : 1,
                      }}
                    />
                    {!item.isSystem && (
                      <CButton
                        color="danger"
                        size="sm"
                        style={{
                          padding: '6px 18px',
                          fontSize: '16px',
                          border: 'none',
                          background: 'rgb(231, 0, 0)',
                          color: 'white',
                          borderRadius: '6px',
                        }}
                        onClick={() => {
                          setEditBoardState((p) => ({
                            ...p,
                            columns: applyColumnOrder(p.columns.filter((_, i) => i !== idx)),
                          }))
                        }}
                      >
                        Remove
                      </CButton>
                    )}
                  </div>
                  )
                })}
              </div>
            </div>
          </div>
        </CModalBody>
        <CModalFooter
          style={{
            borderTop: '1px solid var(--ui-dashboard-border-strong)',
            display: 'flex',
            justifyContent: 'center',
            gap: '0px',
            padding: '20px 24px 24px',
            background: 'var(--ui-dashboard-bg)',
          }}
        >
          <CButton
            variant="outline"
            className="rs_btn-secondary"
            style={{
              borderRadius: '12px',
              padding: '10px 24px',
              minWidth: '101px',
              width: '101px',
              backgroundColor: 'transparent',
              color: 'var(--ui-text-secondary)',
              border: 'none',
              fontSize: '16px',
            }}
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </CButton>          
          <CButton
            color="primary"
            className="rs_btn-primary"
            style={{
              borderRadius: '12px',
              padding: '10px 24px',
              minWidth: '101px',
              width: '101px',
              fontSize: '16px',
              border: 'none',
            }}
            onClick={handleSaveEdit}
            disabled={isLoading}
          >
            {isLoading ? (
                            <CSpinner size="sm" />
                        ) : ( 'Save')}
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default DeleteBoard
